import React, { useEffect } from "react";
import CircleLoader from "../notes/component/CircleLoader";
const ContactSales = () => {
   useEffect(() => {
      const redirectUrl = "https://meetings.hubspot.com/brook-byers?uuid=c7815c4c-352d-41b1-b9ca-d777cfee46f1";
      window.location.href = redirectUrl;
   }, []);

   return (
      <div class=" flex-center h-100 ">
         <CircleLoader />
      </div>
   );
};

export default ContactSales;
